import { TranslateDefaultParser, TranslateParser } from '@ngx-translate/core';

function isDefined(value: any): boolean {
  return typeof value !== 'undefined' && value !== null;
}

export class MyTranslateParser implements TranslateParser {

  templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

  public interpolate(expr: string, params?: any): string {
    if (typeof expr !== 'string' || !params) {
      return expr;
    }

    return expr.replace(this.templateMatcher, (substring: string, b: string) => {
      const r = this.getValue(params, b);
      return isDefined(r) ? r : substring;
    });
  }

  getValue(target = {}, key) {
    return target[key] === '' ? key : target[key];
  }
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/translates/parser.service.ts